import { render, staticRenderFns } from "./PendingVideoConferences.vue?vue&type=template&id=92bf68aa&"
import script from "./PendingVideoConferences.vue?vue&type=script&lang=js&"
export * from "./PendingVideoConferences.vue?vue&type=script&lang=js&"
import style0 from "./PendingVideoConferences.vue?vue&type=style&index=0&id=92bf68aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports